import { useCallback } from 'react';
import { useAppState, useDispatch } from 'state';
import { setConsent, resetConsent, type ConsentType } from 'actions/cookie-consent';

export const useCookieConsent = () => {
  const dispatch = useDispatch();

  const { consentType, hasConsentBeenSet } = useAppState(({ cookieConsent }) => cookieConsent);

  const acceptAll = useCallback(() => {
    dispatch(setConsent('all'));
  }, [dispatch]);

  const declineNonEssential = useCallback(() => {
    dispatch(setConsent('essential'));
  }, [dispatch]);

  const resetConsentPreferences = useCallback(() => {
    dispatch(resetConsent());
  }, [dispatch]);

  const hasAnalyticsConsent = consentType === 'all';
  const hasEssentialConsent = consentType === 'essential' || consentType === 'all';

  return {
    consentType,
    hasConsentBeenSet,
    hasAnalyticsConsent,
    hasEssentialConsent,
    acceptAll,
    declineNonEssential,
    resetConsentPreferences,
  };
};
